"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_REGEX = exports.WHITESPACE_REGEX = exports.NO_LETTERS_REGEX = exports.LETTERS_REGEX = exports.NO_DIGIT_REGEX = exports.DIGIT_REGEX = exports.LETTERS_OR_DIGITS = exports.LETTERS_OR_DIGITS_BRAZILIAN_REGEX = exports.UUID_REGEX = void 0;
exports.UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
exports.LETTERS_OR_DIGITS_BRAZILIAN_REGEX = /^[a-zA-Z0-9]+$/;
exports.LETTERS_OR_DIGITS = /^[a-z0-9]+$/;
exports.DIGIT_REGEX = /\d/;
exports.NO_DIGIT_REGEX = /^[^\d]*$/;
exports.LETTERS_REGEX = /\p{L}/u;
exports.NO_LETTERS_REGEX = /^[^a-zA-Z]*$/;
exports.WHITESPACE_REGEX = /\s/;
exports.EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//# sourceMappingURL=validation.js.map